// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR } from '@calm/evexia-design-tokens';
import { LoginMethod } from '@calm/web-common/dist/user-id';
import { Facebook } from '@mui/icons-material';
import { Box, Theme } from '@rhg/libs/material';
import {
    CHApple as Apple,
    CHMailBrand,
    GoogleColored,
} from '@rhg/libs/material/icons';
import { sxAppend } from '@rhg/libs/material/sx';
import { FACEBOOK_BRAND_COLOR } from '@rhg/libs/material/theme/palette';
import { type ReactNode } from 'react';

const styleFacebookIcon = { color: FACEBOOK_BRAND_COLOR };
const styleAppleIcon = {
    color: (theme: Theme) =>
        theme.palette.mode === 'dark'
            ? DS_COLOR.WHITE_100P
            : DS_COLOR.BLACK_100P,
};
const styleMethodIcon = { width: 20, height: 20 };
const styleMailIcon = { color: 'text.sub' };

interface LoginMethodIconProps {
    loginMethod: LoginMethod;
}

export function LoginMethodIcon({ loginMethod }: LoginMethodIconProps) {
    let icon: ReactNode = null;

    if (loginMethod === 'Google') {
        icon = <GoogleColored style={styleMethodIcon} />;
    } else if (loginMethod === 'Apple') {
        icon = <Apple sx={sxAppend(styleMethodIcon, styleAppleIcon)} />;
    } else if (loginMethod === 'Facebook') {
        icon = <Facebook sx={sxAppend(styleMethodIcon, styleFacebookIcon)} />;
    } else if (loginMethod === 'Manual') {
        icon = <CHMailBrand sx={sxAppend(styleMethodIcon, styleMailIcon)} />;
    }

    if (!icon) return null;

    return (
        <Box data-testid="login-method-icon" display="inline-flex">
            {icon}
        </Box>
    );
}
